import { registerWebComponents } from './register'
import { injectNetwatchBotInWindow, parseNetwatchBot } from './window'

registerWebComponents()

const netwatchBot = parseNetwatchBot()

injectNetwatchBotInWindow(netwatchBot)

export default netwatchBot
